import { FunctionComponent, useState, useEffect } from "react";
import {
  LoadingSpinner,
  PageContainer,
  PageTitle,
} from "src/components/generic";
import InviteMemberModal from "src/components/generic/Modal/InviteMemberModal";
import { TableCheckbox } from "src/components/inputs";
import Table from "src/components/tables/Table";
import { useAuth } from "src/context/AuthContext";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { userTypes } from "src/utils/types";
import { Consultant } from "src/utils/types/UserTypes";

const Members: FunctionComponent = () => {
  const columns: string[] = ["", "ID", "Name", "Email", "Phone"];

  const { user } = useAuth();
  const { setToast } = useToast();

  const [members, setMembers] = useState<Consultant[]>([]);
  const [selectMembers, setSelectMembers] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [open, setModalOpen] = useState<boolean>(false);

  const toggleModal = () => setModalOpen(!open);

  const toggleSelectMembers = (checked: boolean, email: string) =>
    checked
      ? setSelectMembers([...selectMembers, email])
      : setSelectMembers(
          selectMembers.filter(
            (selectedEmail: string) => selectedEmail !== email
          )
        );

  const checkValidation = (email: string) => selectMembers.includes(email);
  console.log({members})
  const rows = members.map((member: any) => [
    <TableCheckbox
      checked={checkValidation(member.userInfo.email)}
      data={member.userInfo.email}
      toggleSelected={toggleSelectMembers}
    />,
    member.userId,
    member.userInfo.name,
    member.userInfo.email,
    member.userInfo.phone,
  ]);

  const fetchMembers = async () => {
    setLoading(true);
    if (!user) return;

    try {
      const result = await dynamo.fetch.membersByCompany(user.userId);
      console.log({result})
      setMembers(result?.members);
    } catch (error: any) {
      setToast({
        message: error?.message || "Failed to Fetch Members",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchMembers();
  }, [user]);
  console.log({columns, rows})
  if (loading) return <LoadingSpinner />;
  return (
    <PageContainer>
      <PageTitle title="Members" />
      <div className="w-full flex justify-between items-center mb-3">
        <InviteMemberModal open={open} toggleModal={toggleModal} />
      </div>
      <Table columns={columns} rows={rows} />
    </PageContainer>
  );
};

export default Members;
